exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-dialog .footer-buttons {\n  float: right; }\n  .email-dialog .footer-buttons .btn {\n    margin-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/email-dialog/email-dialog.component.scss
// module id = ../../../../../resources/assets/src/app/shared/modules/email-dialog/email-dialog.component.scss
// module chunks = main